(function ($, rbt) {

	var visibilityDivs = {
		'xs': $('<div class="block  sm:hidden md:hidden lg:hidden xl:hidden"></div>'),
		'sm': $('<div class="hidden sm:block  md:hidden lg:hidden xl:hidden"></div>'),
		'md': $('<div class="hidden sm:hidden md:block  lg:hidden xl:hidden"></div>'),
		'lg': $('<div class="hidden sm:hidden md:hidden lg:block  xl:hidden"></div>'),
		'xl': $('<div class="hidden sm:hidden md:hidden lg:hidden xl:block "></div>'),
	};
	rbt.use('custom', visibilityDivs);

	var doOnResize = function () {
		// console.log('Current breakpoint: ', rbt.current());
		$('html').removeClass(function(index, className) {
			return (className.match (/(^|\s)viewport-\S+/g) || []).join(' ');
		});
		$('html').addClass('viewport-' + rbt.current());
	};

	$(function() {
		$(window).resize(
			rbt.changed(function () {
				doOnResize();
			})
		).resize();
		// make available globally
		window.rbtViewport = rbt;
	});

})(jQuery, ResponsiveBootstrapToolkit);

